"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Activity = void 0;
var ActivityList_1 = require("./ActivityList");
var types_1 = require("./types");
// tslint:disable:variable-name
var Activity = /** @class */ (function () {
    function Activity(data) {
        this.dateStart = null;
        this.dateEnd = null;
        this.id = data.id;
        this.name = data.name;
        this.title = data.title;
        this.description = data.description;
        this.image = data.image;
        this.activity_id = data.activity_id;
        this.base_num_points = data.base_num_points;
        this.num_points = data.num_points;
        this.category_id = data.category_id;
        this.category_name = data.category_name;
        this.type_id = data.type_id;
        this.type_name = data.type_name;
        this.activity_channel_id = data.activity_channel_id;
        this.activity_channel_name = data.activity_channel_name;
        this.freq_cap = data.freq_cap;
        this.freq_period_id = data.freq_period_id;
        this.freq_period_name = data.freq_period_name;
        this.freq_num_required_attempts = data.freq_num_required_attempts;
        this.redirect_url = data.redirect_url;
        this.points_on_click = data.points_on_click;
        this.action_tags = data.action_tags;
        this.date_awarded = data.date_awarded;
        this.date_created = data.date_created;
        this.extra_data = data.extra_data;
        this.base_extra_data = data.base_extra_data;
        this.public_title = data.public_title;
        this.public_description = data.public_description;
        this.date_start = data.date_start;
        this.date_end = data.date_end;
        this.min_tier_id = data.min_tier_id;
        this.user_num_completions = data.user_num_completions;
        this.group_user_num_completions = data.group_user_num_completions;
        this.group_frequency = data.group_frequency;
        this.is_hidden_by_tier = data.is_hidden_by_tier;
        this.is_locked_by_tier = data.is_locked_by_tier;
        this.campaigns = data.campaigns;
    }
    Object.defineProperty(Activity.prototype, "isFeatured", {
        get: function () {
            return !!this.extra_data && this.extra_data.hasOwnProperty('layout') && this.extra_data.layout === 'featured';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isVideo", {
        get: function () {
            return (!!this.extra_data &&
                this.extra_data.hasOwnProperty('action_type') &&
                typeof this.extra_data.action_type === 'string' &&
                this.extra_data.action_type.toUpperCase() === 'video'.toUpperCase());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isExpressGame", {
        get: function () {
            return (!!this.extra_data &&
                this.extra_data.hasOwnProperty('action_type') &&
                typeof this.extra_data.action_type === 'string' &&
                this.extra_data.action_type.toUpperCase() === 'interactive_game'.toUpperCase());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isAudio", {
        get: function () {
            return (!!this.extra_data &&
                this.extra_data.hasOwnProperty('action_type') &&
                typeof this.extra_data.action_type === 'string' &&
                this.extra_data.action_type.toUpperCase() === 'audio'.toUpperCase());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isDocument", {
        get: function () {
            return (!!this.extra_data &&
                this.extra_data.hasOwnProperty('action_type') &&
                typeof this.extra_data.action_type === 'string' &&
                this.extra_data.action_type.toUpperCase() === 'read_document'.toUpperCase());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isURL", {
        get: function () {
            return (!!this.extra_data &&
                this.extra_data.hasOwnProperty('action_type') &&
                typeof this.extra_data.action_type === 'string' &&
                this.extra_data.action_type.toUpperCase() === 'view_url'.toUpperCase());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isScanTicket", {
        get: function () {
            return !!this.extra_data && this.extra_data.hasOwnProperty('layout') && this.extra_data.layout === 'scan_ticket';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isUploadPhoto", {
        get: function () {
            return (!!this.extra_data &&
                this.extra_data.hasOwnProperty('action_type') &&
                typeof this.extra_data.action_type === 'string' &&
                this.extra_data.action_type.toUpperCase() === 'upload_photo'.toUpperCase());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isSocialConnect", {
        // Checks whether activity is of type Social Connect
        get: function () {
            return (!!this.extra_data &&
                this.extra_data.hasOwnProperty('action_type') &&
                typeof this.extra_data.action_type === 'string' &&
                this.extra_data.action_type.toUpperCase() === 'social_connect'.toUpperCase());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isInviteFriend", {
        get: function () {
            return (!!this.extra_data &&
                this.extra_data.hasOwnProperty('action_type') &&
                typeof this.extra_data.action_type === 'string' &&
                this.extra_data.action_type.toUpperCase() === 'invite_friend'.toUpperCase());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isProfileCompletion", {
        get: function () {
            return (!!this.extra_data &&
                this.extra_data.hasOwnProperty('action_type') &&
                typeof this.extra_data.action_type === 'string' &&
                this.extra_data.action_type.toUpperCase() === 'profile_completion'.toUpperCase());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isNotificationPreference", {
        get: function () {
            return (!!this.extra_data &&
                this.extra_data.hasOwnProperty('action_type') &&
                typeof this.extra_data.action_type === 'string' &&
                this.extra_data.action_type.toUpperCase() === 'notification_preference'.toUpperCase());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isPushNotificationPreference", {
        get: function () {
            return (!!this.extra_data &&
                this.extra_data.hasOwnProperty('action_type') &&
                typeof this.extra_data.action_type === 'string' &&
                this.extra_data.action_type.toUpperCase() === 'push_notification_preference'.toUpperCase());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isMobileAppSignInBonus", {
        get: function () {
            return !!this.extra_data && this.extra_data.hasOwnProperty('layout') && this.extra_data.layout === 'mobile_app_sign_in';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isVisibleOnListPage", {
        get: function () {
            return !this.isMobileAppSignInBonus;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isVisibleOnMobileListPage", {
        get: function () {
            return this.isVisibleOnListPage && !this.isWebOnly;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isVisibleOnWebListPage", {
        get: function () {
            return this.isVisibleOnListPage && !this.isMobileOnly;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isWebOnly", {
        get: function () {
            return !!this.extra_data && this.extra_data.hasOwnProperty('view') && this.extra_data.view === 'web_only';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isMobileOnly", {
        get: function () {
            return !!this.extra_data && this.extra_data.hasOwnProperty('view') && this.extra_data.view === 'mobile_only';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isBrowserView", {
        get: function () {
            return !!this.extra_data && this.extra_data.hasOwnProperty('view') && this.extra_data.view === 'is_not_web_view';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isHiddenFromList", {
        get: function () {
            return !!this.extra_data && this.extra_data.hasOwnProperty('view') && this.extra_data.view === 'hidden';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isPromoCode", {
        get: function () {
            return ((!!this.type_id && this.type_id === types_1.ActivityType['Code Redemption']) ||
                (!!this.extra_data &&
                    this.extra_data.hasOwnProperty('action_type') &&
                    typeof this.extra_data.action_type === 'string' &&
                    this.extra_data.action_type.toUpperCase() === 'promo_code'.toUpperCase()));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isSystemSurvey", {
        get: function () {
            return this.extra_data ? this.extra_data.hasOwnProperty('system_survey') : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isSurvey", {
        get: function () {
            return this.activity_channel_id === types_1.ActivityChannelType.Survey;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isLegacySurvey", {
        get: function () {
            var _a;
            return this.isSurvey && !!((_a = this.extra_data) === null || _a === void 0 ? void 0 : _a.hasOwnProperty('legacy_survey'));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isPoll", {
        get: function () {
            var _a;
            return !!this.type_id && this.type_id === types_1.ActivityType.Poll && ((_a = this.activity_channel_name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'poll';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "isQuiz", {
        get: function () {
            return this.activity_channel_id === types_1.ActivityChannelType.Quiz;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "gameUrl", {
        get: function () {
            return !!this.extra_data && this.extra_data.hasOwnProperty('game_url') ? this.extra_data.game_url : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "gameName", {
        get: function () {
            return !!this.extra_data && this.extra_data.hasOwnProperty('gameName') ? this.extra_data.gameName : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "gameNumber", {
        get: function () {
            return !!this.extra_data && this.extra_data.hasOwnProperty('game_number') ? this.extra_data.game_number : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "portraitMode", {
        get: function () {
            return !!this.extra_data && this.extra_data.hasOwnProperty('game_view') && this.extra_data.game_view === 'portrait';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "customOrder", {
        get: function () {
            return !!this.extra_data && this.extra_data.hasOwnProperty('custom_order_override')
                ? parseInt(this.extra_data.custom_order_override, 10)
                : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "campaignGroupId", {
        get: function () {
            return !!this.extra_data && this.extra_data.hasOwnProperty('campaign_group_id') ? this.extra_data.campaign_group_id : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Activity.prototype, "totalBonusPoints", {
        get: function () {
            var _this = this;
            if (this.campaigns && this.campaigns.length > 0) {
                var totalPointsCampaigns = this.campaigns.map(function (campaign) {
                    if (!!campaign['multiplier']) {
                        return _this.num_points * campaign['multiplier'];
                    }
                    else if (!!campaign['point_gift']) {
                        return _this.num_points + campaign['point_gift'];
                    }
                    else {
                        return 0;
                    }
                });
                return Math.max.apply(Math, totalPointsCampaigns);
            }
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Activity.JsonToActivities = function (data) {
        var activityList = new ActivityList_1.ActivityList();
        data.forEach(function (activity) {
            if (!!activity.extra_data && activity.extra_data.hasOwnProperty('view') && activity.extra_data.view === 'hidden')
                return;
            activityList.push(Activity.JsonToActivity(activity));
        });
        return activityList.getDateStartSorted();
    };
    Activity.JsonToActivity = function (data) { return new Activity(data); };
    return Activity;
}());
exports.Activity = Activity;
//# sourceMappingURL=Activity.js.map